module.exports = __webpack_public_path__ + "static/poem-0d30586f8ef196230542b5636aca5ac9.png";